var _filter, _filter2, _clipPath, _g, _rect, _rect2, _path, _g2, _rect3, _g3, _path2, _path3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFinetuningVisual2 = function SvgFinetuningVisual2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 609 452",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "finetuning-visual2_svg__a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 368,
    width: 569,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_42445"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_137_42445",
    result: "effect2_dropShadow_137_42445"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_137_42445",
    result: "effect3_dropShadow_137_42445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_137_42445",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "finetuning-visual2_svg__b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 315,
    width: 416,
    x: 193,
    y: 137
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_42445"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_137_42445",
    result: "effect2_dropShadow_137_42445"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_137_42445",
    result: "effect3_dropShadow_137_42445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_137_42445",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "finetuning-visual2_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286 207.5h74.538v19H286z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#finetuning-visual2_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 280,
    rx: 16,
    shapeRendering: "crispEdges",
    width: 481,
    x: 44,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 52,
    rx: 12,
    width: 417,
    x: 76,
    y: 96
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1919e5",
    height: 20,
    rx: 4,
    width: 20,
    x: 92,
    y: 112
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.5 123.167 3.375 2.333 5.625-7",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f1f1",
    height: 12,
    rx: 6,
    width: 201,
    x: 136,
    y: 116
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f1f1",
    height: 12,
    rx: 6,
    width: 84,
    x: 380,
    y: 116
  }), /*#__PURE__*/React.createElement("rect", {
    height: 52,
    rx: 12,
    stroke: "#f1f1f1",
    width: 417,
    x: 76,
    y: 96
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 52,
    rx: 12,
    width: 417,
    x: 76,
    y: 156
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1919e5",
    height: 20,
    rx: 4,
    width: 20,
    x: 92,
    y: 172
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.5 183.167 3.375 2.333 5.625-7",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f1f1",
    height: 12,
    rx: 6,
    width: 201,
    x: 136,
    y: 176
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f1f1",
    height: 12,
    rx: 6,
    width: 84,
    x: 380,
    y: 176
  }), /*#__PURE__*/React.createElement("rect", {
    height: 52,
    rx: 12,
    stroke: "#f1f1f1",
    width: 417,
    x: 76,
    y: 156
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 52,
    rx: 12,
    width: 417,
    x: 76,
    y: 216
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1919e5",
    height: 20,
    rx: 4,
    width: 20,
    x: 92,
    y: 232
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.5 243.167 3.375 2.333 5.625-7",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f1f1",
    height: 12,
    rx: 6,
    width: 201,
    x: 136,
    y: 236
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f1f1",
    height: 12,
    rx: 6,
    width: 84,
    x: 380,
    y: 236
  }), /*#__PURE__*/React.createElement("rect", {
    height: 52,
    rx: 12,
    stroke: "#f1f1f1",
    width: 417,
    x: 76,
    y: 216
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 59.5c0 1.658-3.358 3-7.5 3s-7.5-1.342-7.5-3m15 0c0-1.656-3.358-3-7.5-3s-7.5 1.344-7.5 3m15 0V64m-15-4.5V64m0 0c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3m-15 0v4.5c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3V64",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.994 69h3.99c3.15 0 4.844-2.044 4.844-5.152 0-3.164-1.722-5.264-4.732-5.264h-4.102zm1.946-1.652v-7.112h1.974c2.044 0 2.926 1.442 2.926 3.612 0 2.184-.924 3.5-2.982 3.5zM119.965 69h1.722v-.126c-.168-.112-.28-.434-.28-1.05V63.89c0-.994-.364-1.708-1.064-2.128-.49-.308-1.148-.434-2.002-.434-2.128 0-3.136 1.162-3.192 2.436h1.68c.042-.742.532-1.204 1.526-1.204.896 0 1.344.434 1.344 1.078 0 .672-.616.868-1.848 1.022-1.778.21-3.066.616-3.066 2.31 0 1.456 1.092 2.212 2.548 2.212 1.19 0 1.862-.49 2.352-1.148h.028c.028.504.126.798.252.966zm-2.114-1.036c-.686 0-1.288-.238-1.288-1.036 0-.826.63-1.05 1.722-1.26.546-.112 1.106-.266 1.456-.49v1.106c0 .84-.672 1.68-1.89 1.68zm4.615-5.222h1.148v4.578c0 1.316.826 1.75 2.03 1.75.476 0 .882-.056 1.176-.112v-1.386h-.084c-.14.028-.392.056-.574.056-.504 0-.798-.154-.798-.7v-4.186h1.498v-1.218h-1.498v-2.38h-1.75v2.38h-1.148zM133.021 69h1.722v-.126c-.168-.112-.28-.434-.28-1.05V63.89c0-.994-.364-1.708-1.064-2.128-.49-.308-1.148-.434-2.002-.434-2.128 0-3.136 1.162-3.192 2.436h1.68c.042-.742.532-1.204 1.526-1.204.896 0 1.344.434 1.344 1.078 0 .672-.616.868-1.848 1.022-1.778.21-3.066.616-3.066 2.31 0 1.456 1.092 2.212 2.548 2.212 1.19 0 1.862-.49 2.352-1.148h.028c.028.504.126.798.252.966zm-2.114-1.036c-.686 0-1.288-.238-1.288-1.036 0-.826.63-1.05 1.722-1.26.546-.112 1.106-.266 1.456-.49v1.106c0 .84-.672 1.68-1.89 1.68zm5.2 3.542h1.778v-2.002c0-.7-.028-1.176-.056-1.456h.042c.462.756 1.274 1.19 2.268 1.19 2.016 0 3.276-1.554 3.276-3.962 0-2.38-1.274-3.948-3.22-3.948-1.05 0-1.792.448-2.324 1.302h-.042v-1.106h-1.722zm3.696-3.682c-1.372 0-1.988-1.092-1.988-2.506s.63-2.548 1.974-2.548c1.218 0 1.82 1.064 1.82 2.548 0 1.47-.63 2.506-1.806 2.506zm8.307 1.4c2.324 0 3.794-1.736 3.794-3.948 0-2.226-1.47-3.948-3.794-3.948s-3.822 1.722-3.822 3.948c0 2.212 1.498 3.948 3.822 3.948zm-.014-1.344c-1.316 0-2.002-1.106-2.002-2.604 0-1.512.686-2.632 2.002-2.632 1.302 0 2.002 1.12 2.002 2.632 0 1.498-.7 2.604-2.002 2.604zm5.032-7.574h1.82v-1.722h-1.82zm.028 8.694h1.778v-7.476h-1.778zm5.126-7.476h-1.736V69h1.778v-4.382c0-1.064.7-1.82 1.694-1.82.91 0 1.428.546 1.428 1.428V69h1.778v-5.068c0-1.61-.966-2.604-2.576-2.604-1.05 0-1.834.462-2.324 1.288h-.042zm5.924 1.218h1.148v4.578c0 1.316.826 1.75 2.03 1.75.476 0 .882-.056 1.176-.112v-1.386h-.084c-.14.028-.392.056-.574.056-.504 0-.798-.154-.798-.7v-4.186h1.498v-1.218h-1.498v-2.38h-1.75v2.38h-1.148zm8.707 6.496c1.848 0 3.192-.826 3.192-2.394 0-1.82-1.4-2.156-2.814-2.422-1.134-.21-1.904-.336-1.904-.994 0-.518.434-.896 1.26-.896.882 0 1.358.35 1.484.994h1.694c-.182-1.302-1.176-2.198-3.164-2.198-1.75 0-2.954.812-2.954 2.226 0 1.694 1.33 2.016 2.73 2.296 1.176.224 1.932.364 1.932 1.106 0 .602-.462 1.022-1.442 1.022-.952 0-1.638-.378-1.778-1.274h-1.708c.112 1.512 1.344 2.534 3.472 2.534z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 279,
    rx: 15.5,
    shapeRendering: "crispEdges",
    stroke: "#f6f6f6",
    width: 480,
    x: 44.5,
    y: 24.5
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#finetuning-visual2_svg__b)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 227,
    rx: 16,
    width: 328,
    x: 237,
    y: 161
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1919e5",
    height: 40,
    rx: 5,
    width: 264,
    x: 269,
    y: 314
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.873 333.422a.852.852 0 0 0-.726-1.299h-2.897v-7.5l-6.123 9.951a.853.853 0 0 0 .725 1.299h2.898v7.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.98 339h1.932v-4.466h4.55v-1.61h-4.55v-2.674h5.46v-1.666h-7.392zm8.65-8.694h1.82v-1.722h-1.82zm.028 8.694h1.778v-7.476h-1.778zm5.126-7.476h-1.736V339h1.778v-4.382c0-1.064.7-1.82 1.694-1.82.91 0 1.428.546 1.428 1.428V339h1.778v-5.068c0-1.61-.966-2.604-2.576-2.604-1.05 0-1.834.462-2.324 1.288h-.042zm9.938 7.7c1.834 0 3.038-.994 3.402-2.338h-1.736c-.238.616-.798.98-1.652.98-1.246 0-1.932-.868-2.058-2.156h5.586c.014-1.386-.336-2.562-1.064-3.332-.63-.672-1.484-1.05-2.576-1.05-2.212 0-3.71 1.722-3.71 3.948 0 2.212 1.428 3.948 3.808 3.948zm-.098-6.608c1.078 0 1.736.742 1.806 1.974h-3.724c.154-1.176.756-1.974 1.918-1.974zm7.978.126h1.148v4.578c0 1.316.826 1.75 2.03 1.75.476 0 .882-.056 1.176-.112v-1.386h-.084c-.14.028-.392.056-.574.056-.504 0-.798-.154-.798-.7v-4.186h1.498v-1.218H381.5v-2.38h-1.75v2.38h-1.148zM390.784 339v-7.476h-1.764v4.382c0 1.036-.644 1.806-1.652 1.806-.896 0-1.4-.518-1.4-1.4v-4.788h-1.778v5.04c0 1.61.952 2.632 2.59 2.632 1.05 0 1.708-.448 2.254-1.26h.028V339zm3.36-7.476h-1.736V339h1.778v-4.382c0-1.064.7-1.82 1.694-1.82.91 0 1.428.546 1.428 1.428V339h1.778v-5.068c0-1.61-.966-2.604-2.576-2.604-1.05 0-1.834.462-2.324 1.288h-.042zm9.938 7.7c1.834 0 3.038-.994 3.402-2.338h-1.736c-.238.616-.798.98-1.652.98-1.246 0-1.932-.868-2.058-2.156h5.586c.014-1.386-.336-2.562-1.064-3.332-.63-.672-1.484-1.05-2.576-1.05-2.212 0-3.71 1.722-3.71 3.948 0 2.212 1.428 3.948 3.808 3.948zm-.098-6.608c1.078 0 1.736.742 1.806 1.974h-3.724c.154-1.176.756-1.974 1.918-1.974zm10.162-1.092h-1.736V339h1.778v-4.382c0-1.064.7-1.82 1.694-1.82.91 0 1.428.546 1.428 1.428V339h1.778v-5.068c0-1.61-.966-2.604-2.576-2.604-1.05 0-1.834.462-2.324 1.288h-.042zm9.938 7.7c1.834 0 3.038-.994 3.402-2.338h-1.736c-.238.616-.798.98-1.652.98-1.246 0-1.932-.868-2.058-2.156h5.586c.014-1.386-.336-2.562-1.064-3.332-.63-.672-1.484-1.05-2.576-1.05-2.212 0-3.71 1.722-3.71 3.948 0 2.212 1.428 3.948 3.808 3.948zm-.098-6.608c1.078 0 1.736.742 1.806 1.974h-3.724c.154-1.176.756-1.974 1.918-1.974zm6.318 6.384h1.708l.966-3.556c.196-.784.476-2.198.476-2.198h.028s.266 1.414.462 2.198l.938 3.556h1.708l2.38-7.476h-1.792l-.994 3.486c-.266.91-.476 2.268-.476 2.268h-.028s-.252-1.414-.476-2.268l-.952-3.486h-1.568l-.924 3.486c-.252.896-.49 2.254-.49 2.254h-.028s-.224-1.386-.462-2.254l-.966-3.486h-1.848zm13.141 0h1.778v-4.424c0-1.05.728-1.778 1.554-1.778.742 0 1.176.518 1.176 1.372V339h1.778v-4.424c0-1.05.644-1.778 1.512-1.778.728 0 1.218.518 1.218 1.372V339h1.778v-5.068c0-1.61-.896-2.604-2.422-2.604-.924 0-1.764.434-2.352 1.4h-.028c-.336-.924-1.05-1.4-1.988-1.4-1.022 0-1.764.49-2.24 1.33h-.042v-1.134h-1.722zm15.803.224c2.324 0 3.794-1.736 3.794-3.948 0-2.226-1.47-3.948-3.794-3.948s-3.822 1.722-3.822 3.948c0 2.212 1.498 3.948 3.822 3.948zm-.014-1.344c-1.316 0-2.002-1.106-2.002-2.604 0-1.512.686-2.632 2.002-2.632 1.302 0 2.002 1.12 2.002 2.632 0 1.498-.7 2.604-2.002 2.604zm7.93 1.358c1.022 0 1.834-.462 2.296-1.33h.028V339h1.722v-10.416h-1.778v2.464c0 .56.028 1.148.056 1.554h-.028c-.49-.784-1.26-1.274-2.296-1.274-1.904 0-3.248 1.568-3.248 3.948 0 2.436 1.274 3.962 3.248 3.962zm.364-1.456c-1.204 0-1.806-1.022-1.806-2.52 0-1.47.602-2.548 1.806-2.548 1.316 0 1.974 1.064 1.974 2.562 0 1.47-.658 2.506-1.974 2.506zm8.741 1.442c1.834 0 3.038-.994 3.402-2.338h-1.736c-.238.616-.798.98-1.652.98-1.246 0-1.932-.868-2.058-2.156h5.586c.014-1.386-.336-2.562-1.064-3.332-.63-.672-1.484-1.05-2.576-1.05-2.212 0-3.71 1.722-3.71 3.948 0 2.212 1.428 3.948 3.808 3.948zm-.098-6.608c1.078 0 1.736.742 1.806 1.974h-3.724c.154-1.176.756-1.974 1.918-1.974zm4.913 6.384h1.792v-10.416h-1.792z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.924 295h6.48v-1.116h-5.256v-3.012h4.632v-1.02h-4.632v-2.7h5.124v-1.08h-6.348zm10.191.192c1.512 0 2.592-.672 2.592-1.98 0-1.5-1.104-1.788-2.388-2.04-1.092-.216-1.716-.348-1.716-1.02 0-.492.372-.9 1.248-.9.924 0 1.38.372 1.476 1.032h1.116c-.144-1.116-.948-1.872-2.568-1.872-1.5 0-2.364.696-2.364 1.8 0 1.416 1.14 1.68 2.4 1.944 1.14.228 1.68.408 1.68 1.116 0 .576-.432 1.02-1.452 1.02-.924 0-1.644-.312-1.776-1.248h-1.128c.096 1.308 1.104 2.148 2.88 2.148zm3.284-5.772h1.008v4.32c0 .948.6 1.296 1.464 1.308.288 0 .6-.036.9-.108v-.936h-.036c-.12.036-.372.084-.564.084-.408 0-.66-.132-.66-.6v-4.068h1.332v-.864h-1.332v-2.028h-1.104v2.028h-1.008zm4.579-2.052h1.164v-1.296h-1.164zm.024 7.632h1.116v-6.444h-1.116zm2.649 0h1.116v-3.972c0-.984.828-1.692 1.596-1.692.66 0 1.104.468 1.104 1.26V295h1.104v-3.972c0-.984.708-1.692 1.524-1.692.648 0 1.164.468 1.164 1.26V295h1.116v-4.5c0-1.344-.816-2.1-1.992-2.1-.78 0-1.536.396-1.992 1.2h-.024c-.264-.792-.888-1.2-1.668-1.2-.828 0-1.512.42-1.908 1.116h-.036v-.96h-1.104zm12.139.132c1.092 0 1.752-.516 2.16-1.08h.012c.12.684.456 1.008 1.14 1.008.264 0 .444-.048.6-.096v-.78h-.048c-.564.12-.684-.156-.684-.672V290.5c0-.864-.324-1.428-.864-1.752-.408-.24-.948-.348-1.56-.348-1.74 0-2.568.972-2.616 2.064h1.08c.036-.768.528-1.248 1.548-1.248.888 0 1.38.432 1.38 1.128 0 .66-.612.816-1.56.924-1.668.204-2.772.528-2.772 2.028 0 1.236.96 1.836 2.184 1.836zm.276-.816c-.648 0-1.284-.204-1.284-1.032 0-.888.696-1.08 1.752-1.26.528-.096 1.092-.252 1.416-.456v1.056c0 .744-.6 1.692-1.884 1.692zm4.029-4.896h1.008v4.32c0 .948.6 1.296 1.464 1.308.288 0 .6-.036.9-.108v-.936h-.036c-.12.036-.372.084-.564.084-.408 0-.66-.132-.66-.6v-4.068h1.332v-.864h-1.332v-2.028h-1.104v2.028h-1.008zm7.34 5.76c1.488 0 2.52-.816 2.808-2.016h-1.092c-.204.684-.816 1.104-1.704 1.104-1.248 0-1.932-.96-2.016-2.22h4.944c0-1.092-.264-2.016-.792-2.652-.504-.624-1.248-.996-2.208-.996-1.848 0-3.084 1.512-3.084 3.384 0 1.884 1.164 3.396 3.144 3.396zm-.06-5.916c1.116 0 1.752.744 1.812 1.98h-3.732c.144-1.14.756-1.98 1.92-1.98zm6.686 5.928c.9 0 1.584-.42 1.992-1.116h.024V295h1.104v-8.928h-1.116v2.28c0 .432.012.9.036 1.188h-.024c-.408-.684-1.128-1.14-2.04-1.14-1.596 0-2.82 1.272-2.82 3.396 0 2.076 1.104 3.396 2.844 3.396zm.084-.924c-1.188 0-1.788-1.044-1.788-2.46s.6-2.472 1.788-2.472c1.296 0 1.98 1.02 1.98 2.472 0 1.416-.6 2.46-1.98 2.46zm10.552.912c1.632 0 2.652-.924 2.796-2.46h-1.104c-.084.96-.684 1.548-1.692 1.548-1.32 0-2.004-1.092-2.004-2.484s.684-2.484 2.004-2.484c.936 0 1.512.516 1.668 1.356h1.116c-.228-1.38-1.236-2.256-2.784-2.256-1.932 0-3.144 1.512-3.144 3.384 0 1.884 1.212 3.396 3.144 3.396zm6.727 0c1.944 0 3.132-1.512 3.132-3.396 0-1.872-1.188-3.384-3.132-3.384s-3.156 1.512-3.156 3.384c0 1.884 1.212 3.396 3.156 3.396zm-.012-.912c-1.32 0-2.004-1.092-2.004-2.484s.684-2.496 2.004-2.496 2.004 1.104 2.004 2.496-.684 2.484-2.004 2.484zm6.801.924c1.512 0 2.592-.672 2.592-1.98 0-1.5-1.104-1.788-2.388-2.04-1.092-.216-1.716-.348-1.716-1.02 0-.492.372-.9 1.248-.9.924 0 1.38.372 1.476 1.032h1.116c-.144-1.116-.948-1.872-2.568-1.872-1.5 0-2.364.696-2.364 1.8 0 1.416 1.14 1.68 2.4 1.944 1.14.228 1.68.408 1.68 1.116 0 .576-.432 1.02-1.452 1.02-.924 0-1.644-.312-1.776-1.248h-1.128c.096 1.308 1.104 2.148 2.88 2.148zm3.284-5.772h1.008v4.32c0 .948.6 1.296 1.464 1.308.288 0 .6-.036.9-.108v-.936h-.036c-.12.036-.372.084-.564.084-.408 0-.66-.132-.66-.6v-4.068h1.332v-.864h-1.332v-2.028h-1.104v2.028h-1.008zM484.791 296.404h.744v-1.32c1.716-.084 3.012-.996 3.012-2.568 0-1.728-1.332-2.184-3.012-2.556v-2.424c.768.12 1.212.528 1.308 1.176h1.512c-.132-1.392-1.104-2.232-2.82-2.364v-.936h-.744v.924c-1.692.072-2.916.912-2.916 2.388 0 1.704 1.26 2.1 2.892 2.484 0 0 .012.012.024.012v2.628c-1.044-.12-1.548-.672-1.656-1.572h-1.572c.06 1.5 1.104 2.664 3.228 2.808zm2.184-3.804c0 .732-.648 1.164-1.44 1.26v-2.46c.936.252 1.44.504 1.44 1.2zm-3.552-3.948c0-.648.528-1.068 1.368-1.14v2.28c-.936-.252-1.368-.528-1.368-1.14zM493.675 295h1.536v-2.004h1.32v-1.188h-1.32v-5.448h-1.44l-4.164 5.232v1.404h4.068zm-2.94-3.132v-.024s.612-.648.96-1.068l1.224-1.548c.348-.444.792-1.152.792-1.152h.024s-.06.804-.06 1.284v2.448h-1.692c-.48 0-1.248.06-1.248.06zm6.56 3.132h1.668v-1.668h-1.668zm2.668 0h6.288v-1.368h-4.224v-.06c.516-.864 1.752-1.452 2.64-2.136.936-.624 1.656-1.224 1.656-2.484 0-1.524-1.116-2.676-2.988-2.676-1.14 0-2.016.384-2.532 1.02-.444.552-.672 1.2-.672 2.112h1.548c0-.612.132-1.068.432-1.392.264-.3.636-.456 1.14-.456.912 0 1.464.576 1.464 1.428 0 .78-.468 1.188-1.26 1.692-.84.552-1.86 1.152-2.58 1.956-.54.612-.876 1.32-.912 2.364zm10.949.204c2.208 0 3.564-1.752 3.564-4.476 0-2.76-1.392-4.464-3.552-4.464-2.124 0-3.552 1.728-3.552 4.464 0 2.724 1.392 4.476 3.54 4.476zm.012-1.296c-1.32 0-1.92-1.26-1.92-3.18 0-1.932.6-3.192 1.92-3.192 1.332 0 1.92 1.272 1.92 3.192 0 1.944-.564 3.18-1.92 3.18zM491.549 270h6.288v-1.368h-4.224v-.06c.516-.864 1.752-1.452 2.64-2.136.936-.624 1.656-1.224 1.656-2.484 0-1.524-1.116-2.676-2.988-2.676-1.14 0-2.016.384-2.532 1.02-.444.552-.672 1.2-.672 2.112h1.548c0-.612.132-1.068.432-1.392.264-.3.636-.456 1.14-.456.912 0 1.464.576 1.464 1.428 0 .78-.468 1.188-1.26 1.692-.84.552-1.86 1.152-2.58 1.956-.54.612-.876 1.32-.912 2.364zm10.697 0h1.488v-4.656c0-.972-.108-2.784-.108-2.784h.024s.372 1.644.66 2.532l1.704 4.908h1.344l1.692-4.908c.288-.888.66-2.532.66-2.532h.024s-.108 1.812-.108 2.784V270h1.548v-8.928h-2.244l-1.44 4.248c-.336 1.056-.768 3-.768 3h-.036s-.432-1.956-.78-3l-1.464-4.248h-2.196zM282.372 262.152h2.928V270h1.236v-7.848h2.94v-1.08h-7.104zm9.731 8.028c1.944 0 3.132-1.512 3.132-3.396 0-1.872-1.188-3.384-3.132-3.384s-3.156 1.512-3.156 3.384c0 1.884 1.212 3.396 3.156 3.396zm-.012-.912c-1.32 0-2.004-1.092-2.004-2.484s.684-2.496 2.004-2.496 2.004 1.104 2.004 2.496-.684 2.484-2.004 2.484zm8.565.732h1.308l-2.748-4.128 2.46-2.316h-1.392l-2.796 2.748c.024-.312.048-.768.048-.996v-4.236h-1.116V270h1.116v-2.532l.912-.864zm4.701.18c1.488 0 2.52-.816 2.808-2.016h-1.092c-.204.684-.816 1.104-1.704 1.104-1.248 0-1.932-.96-2.016-2.22h4.944c0-1.092-.264-2.016-.792-2.652-.504-.624-1.248-.996-2.208-.996-1.848 0-3.084 1.512-3.084 3.384 0 1.884 1.164 3.396 3.144 3.396zm-.06-5.916c1.116 0 1.752.744 1.812 1.98h-3.732c.144-1.14.756-1.98 1.92-1.98zm5.294-.708h-1.104V270h1.116v-3.924c0-1.032.72-1.74 1.716-1.74.876 0 1.416.468 1.416 1.296V270h1.104v-4.5c0-1.344-.828-2.1-2.172-2.1-.936 0-1.572.42-2.04 1.068h-.036zm8.223 6.636c1.512 0 2.592-.672 2.592-1.98 0-1.5-1.104-1.788-2.388-2.04-1.092-.216-1.716-.348-1.716-1.02 0-.492.372-.9 1.248-.9.924 0 1.38.372 1.476 1.032h1.116c-.144-1.116-.948-1.872-2.568-1.872-1.5 0-2.364.696-2.364 1.8 0 1.416 1.14 1.68 2.4 1.944 1.14.228 1.68.408 1.68 1.116 0 .576-.432 1.02-1.452 1.02-.924 0-1.644-.312-1.776-1.248h-1.128c.096 1.308 1.104 2.148 2.88 2.148z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f6f6f6",
    height: 46,
    rx: 5,
    width: 264,
    x: 269,
    y: 194
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#finetuning-visual2_svg__c)",
    fill: "#000",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.133 214.918c-1.095 0-1.877.385-2.261 1.114l-.207.395v-1.319h-1.783v8.015h1.876v-4.768c0-1.14.602-1.793 1.651-1.793 1 0 1.573.636 1.573 1.745v4.816h1.876v-5.16c0-1.908-1.018-3.045-2.725-3.045zm-9.095 0c-2.213 0-3.583 1.42-3.583 3.706v1.125c0 2.198 1.386 3.564 3.618 3.564 1.493 0 2.54-.563 3.198-1.72l-1.162-.688c-.487.667-1.264 1.081-2.035 1.081-1.13 0-1.804-.717-1.804-1.92v-.318h5.234v-1.329c0-2.13-1.359-3.501-3.464-3.501zm1.759 3.534h-3.534v-.192c0-1.32.63-2.048 1.774-2.048 1.101 0 1.759.718 1.759 1.92zm28.687-4.663v-1.533h-6.488v1.533h2.275v7.797h-2.275v1.533h6.488v-1.533h-2.276v-7.797zm-49.188-1.754c-2.897 0-4.698 1.856-4.698 4.846v1.617c0 2.989 1.8 4.847 4.698 4.847s4.699-1.858 4.699-4.847v-1.617c-.001-2.993-1.804-4.846-4.699-4.846zm2.76 6.574c0 1.985-1.006 3.123-2.76 3.123s-2.759-1.138-2.759-3.123v-1.839c0-1.985 1.006-3.124 2.76-3.124 1.753 0 2.76 1.139 2.76 3.124zm7.829-3.691c-.984 0-1.836.42-2.281 1.121l-.201.32v-1.251h-1.784v10.772h1.876v-3.901l.201.306c.422.644 1.246 1.028 2.205 1.028 1.618 0 3.249-1.087 3.249-3.516v-1.363c0-1.75-1.006-3.516-3.265-3.516zm1.389 4.785c0 1.291-.733 2.094-1.911 2.094-1.099 0-1.866-.849-1.866-2.062v-1.206c0-1.228.773-2.093 1.882-2.093 1.17 0 1.897.802 1.897 2.093zm23.769-7.446-3.785 10.866h1.905l.725-2.329h4.351l.007.022.717 2.307h1.905l-3.791-10.867zm-.69 7.004 1.707-5.493 1.69 5.493zM302.93 215.29a4.832 4.832 0 0 0 .209-1.97 4.791 4.791 0 0 0-.601-1.883c-.488-.872-1.231-1.561-2.124-1.97s-1.889-.516-2.845-.306c-.431-.5-.961-.9-1.555-1.172a4.456 4.456 0 0 0-1.886-.407 4.53 4.53 0 0 0-2.722.906 4.74 4.74 0 0 0-1.68 2.381 4.506 4.506 0 0 0-1.763.799 4.65 4.65 0 0 0-1.286 1.477 4.862 4.862 0 0 0 .568 5.564 4.805 4.805 0 0 0 .392 3.849 4.668 4.668 0 0 0 2.125 1.975 4.505 4.505 0 0 0 2.848.306c.431.5.96.899 1.553 1.171a4.463 4.463 0 0 0 1.884.408 4.53 4.53 0 0 0 2.722-.906 4.732 4.732 0 0 0 1.679-2.381 4.506 4.506 0 0 0 1.764-.8 4.657 4.657 0 0 0 1.285-1.476c.491-.87.701-1.877.599-2.878-.102-1-.51-1.941-1.166-2.687zm-6.883 9.9c-.803 0-1.581-.29-2.196-.819.027-.016.079-.043.109-.063l3.648-2.166a.606.606 0 0 0 .299-.533v-5.289l1.541.915c.008.004.016.01.021.018s.009.017.009.026v4.378c0 .936-.361 1.834-1.004 2.496a3.389 3.389 0 0 1-2.427 1.037zm-7.373-3.239a3.6 3.6 0 0 1-.411-2.365l.109.067 3.648 2.166a.586.586 0 0 0 .599 0l4.45-2.647v1.829c.001.01 0 .019-.004.028s-.01.016-.017.022l-3.687 2.188a3.352 3.352 0 0 1-2.603.351 3.446 3.446 0 0 1-2.084-1.643zm-.956-8.189a3.44 3.44 0 0 1 1.786-1.548v4.458c0 .109.027.215.08.309a.601.601 0 0 0 .22.225l4.451 2.643-1.546.918a.05.05 0 0 1-.026.009.046.046 0 0 1-.026-.004l-3.686-2.189a3.518 3.518 0 0 1-1.598-2.143 3.615 3.615 0 0 1 .342-2.678zm12.662 3.03-4.452-2.644 1.54-.915a.045.045 0 0 1 .025-.009.046.046 0 0 1 .026.004l3.687 2.189a3.49 3.49 0 0 1 1.326 1.424 3.616 3.616 0 0 1-.314 3.773 3.446 3.446 0 0 1-1.543 1.171v-4.457a.608.608 0 0 0-.298-.536zm1.534-2.375c-.027-.017-.074-.047-.108-.066l-3.648-2.167a.586.586 0 0 0-.599 0l-4.451 2.643v-1.828a.054.054 0 0 1 .005-.028.072.072 0 0 1 .017-.022l3.686-2.188a3.356 3.356 0 0 1 3.678.163 3.51 3.51 0 0 1 1.203 1.535c.252.619.326 1.298.216 1.959zm-9.647 3.263-1.541-.915a.06.06 0 0 1-.02-.019.055.055 0 0 1-.01-.025v-4.378c0-.671.185-1.328.535-1.894s.849-1.019 1.44-1.303a3.342 3.342 0 0 1 1.895-.305 3.381 3.381 0 0 1 1.758.788l-.11.063-3.647 2.166a.623.623 0 0 0-.3.533zm.837-1.857 1.983-1.178 1.982 1.178v2.354l-1.982 1.177-1.983-1.177z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.371 223.256c2.288 0 3.744-1.376 3.872-3.36h-1.984c-.112 1.12-.784 1.776-1.904 1.776-1.488 0-2.256-1.248-2.256-2.928 0-1.728.768-2.96 2.256-2.96 1.024 0 1.664.592 1.856 1.52h1.984c-.304-1.84-1.68-3.072-3.856-3.072-2.624 0-4.304 1.968-4.304 4.512 0 2.528 1.696 4.512 4.336 4.512zm12.677-.256v-8.544h-2.016v5.008c0 1.184-.736 2.064-1.888 2.064-1.024 0-1.6-.592-1.6-1.6v-5.472h-2.032v5.76c0 1.84 1.088 3.008 2.96 3.008 1.2 0 1.952-.512 2.576-1.44h.032V223zm3.825-8.544h-1.968V223h2.032v-4.288c0-1.648 1.008-2.56 2.352-2.544.208 0 .368.016.56.064h.064v-1.824c-.144-.064-.304-.08-.544-.08-1.088 0-1.904.56-2.448 1.664h-.048zm4.343-1.392h2.08v-1.968h-2.08zm.032 9.936h2.032v-8.544h-2.032zm7.795.256c2.096 0 3.472-1.136 3.888-2.672h-1.984c-.272.704-.912 1.12-1.888 1.12-1.424 0-2.208-.992-2.352-2.464h6.384c.016-1.584-.384-2.928-1.216-3.808-.72-.768-1.696-1.2-2.944-1.2-2.528 0-4.24 1.968-4.24 4.512 0 2.528 1.632 4.512 4.352 4.512zm-.112-7.552c1.232 0 1.984.848 2.064 2.256h-4.256c.176-1.344.864-2.256 2.192-2.256z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m512.25 212.989-7.861 7.861a.55.55 0 0 1-.778 0l-7.861-7.861",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 226,
    rx: 15.5,
    stroke: "#f6f6f6",
    width: 327,
    x: 237.5,
    y: 161.5
  }))));
};

export default SvgFinetuningVisual2;